export default "__VITE_ASSET__DjQJXrrV__"